import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import {LoadingIndicator, B2BSpinner, PricingBreakdown } from "halifax";
import { CallState } from "redmond";
import clsx from "clsx";
import { useBusinessExperimentsById } from "@capone/experiments";
import { getFdaDisplayName } from "@capone/common";
import { PriceBreakdownConnectorProps } from "./container";
import "./styles.scss";

export interface IPriceBreakdownProps
  extends PriceBreakdownConnectorProps,
    RouteComponentProps {
  isMobile?: boolean;
  className?: string;
}

export const PriceBreakdown = ({
  tripPricingCallState,
  currency,
  lineItems,
  summaryLineItems,
  pricingParams,
  fetchTripPricing,
  className,
  cfarOfferText,
  isVITripSelected,
  ancillaries,
  fdaProductVariant,
  userPassengerCallState,
}: IPriceBreakdownProps) => {
  const freeFdaVariant = useBusinessExperimentsById("corp-free-fda")?.variant;
  const isFreeFdaEnabled =
    freeFdaVariant === "available" || freeFdaVariant === "available_phase2";

  useEffect(() => {
    if (userPassengerCallState === CallState.InProcess) {
      return;
    }

    fetchTripPricing();
  }, [
    pricingParams.ancillaryIds,
    pricingParams.tripId,
    pricingParams.fareId,
    pricingParams.lapInfants.length,
    pricingParams.seatedPassengers.length,
    fetchTripPricing,
    userPassengerCallState,
  ]);

  return (
    <>
      {tripPricingCallState === CallState.InProcess ? (
        <LoadingIndicator
          indicatorSize="small"
          indicator={B2BSpinner}
          message="Fetching latest price"
         />
      ) : (
        <PricingBreakdown
          className={clsx("price-breakdown", className)}
          pricingItems={lineItems}
          summaryItems={summaryLineItems}
          currencySymbol={currency.currencySymbol}
          currencyCode={currency.currencyCode}
          isVITripSelected={isVITripSelected}
          ancillaries={{
            ...ancillaries,
            cfarText: cfarOfferText,
            isFreeFdaEnabled,
            fdaProductVariant,
            disruptionProtectionText: () =>
              getFdaDisplayName({
                isFreeFdaEnabled,
                productVariant: fdaProductVariant,
              }),
          }}
        />
      )}
    </>
  );
};
